import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, message } from 'antd';
import { GoogleMap, DirectionsRenderer, useLoadScript, Autocomplete, DirectionsService } from '@react-google-maps/api';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import BotonWhatsapp from '../../newInterface/botonWhatsapp/botonWhatsapp';
import './maps.css';

const mapContainerStyle = {
    height: '100vh',
    width: '100%'
};

const center = {
    lat: 4.7110,
    lng: -74.0721
};

const librariesMaps = ['places'];

const AnyReactComponent = ({ text, onMarkerDragEnd }) => (
    <div draggable onDragEnd={onMarkerDragEnd} style={{ cursor: 'pointer' }}>
        {text}
    </div>
);

const TIME_SLOTS = [
    { label: 'Mañana (8:00 - 12:00)', start: '08:00', end: '12:00' },
    { label: 'Tarde (12:00 - 17:00)', start: '12:00', end: '17:00' },
    { label: 'Noche (17:00 - 22:00)', start: '17:00', end: '22:00' },
];

const Visitas = () => {
    // 1. Load Google Maps script first
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: 'AIzaSyAbErc-9C5rqyrGudtyKlk7LJOfqhbu9c0',
        libraries: librariesMaps,
    });

    // 2. Get ID and initialize refs
    const id = localStorage.getItem('usuario_id');
    const navigate = useNavigate();
    const originRef = useRef(null);
    const destinationRef = useRef(null);

    // 3. All state declarations
    const [isLoading, setIsLoading] = useState(false);
    const [autocompletes, setAutocompletes] = useState({});
    const [autocomplete, setAutocomplete] = useState(null);
    const [destinations, setDestinations] = useState([{ address: '', location: { lat: null, lng: null } }]);
    const [cantidad, setCantidad] = useState(0);
    const [nombre, setNombre] = useState('');
    const [direccion, setDireccion] = useState('');
    const [estado, setEstado] = useState('');
    const [telefono, setTelefono] = useState('');
    const [fecha_de_entrega, setFechaDeEntrega] = useState('');
    // NEW state variables
    const [horaInicio, setHoraInicio] = useState('');
    const [horaFinal, setHoraFinal] = useState('');
    const [fechaEntregaRepartidor, setFechaEntregaRepartidor] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isMapModalVisible, setIsMapModalVisible] = useState(false); // Moved this up
    const [directionsResponse, setDirectionsResponse] = useState(null);
    const [origin, setOrigin] = useState('');
    const [destination, setDestination] = useState('');
    const [productType, setProductType] = useState('');
    const [productos, setProductos] = useState([]);
    const [selectedProducto, setSelectedProducto] = useState(null);
    const [email, setEmail] = useState('');
    const [costoEnvio, setCostoEnvio] = useState('');
    const [repartidores, setRepartidores] = useState([]);
    const [selectedRepartidorId, setSelectedRepartidorId] = useState('');

    // Nuevo Modal producto
    const [isNewProductModalVisible, setIsNewProductModalVisible] = useState(false);
    const [newProductData, setNewProductData] = useState({
        nombre_producto: '',
        id_sucursal: id,
        id_categoria: '',
        cantidad_disponible: '',
        precio_proveedor: '',
        precio_sugerido: '',
        peso_producto: '',
        descripcion_producto: '',
        sku: '',
        estado_variacion: false
    });
    const [productosSeleccionados, setProductosSeleccionados] = useState([]);
    const [touched, setTouched] = useState({
        newProductName: false,
        newQuantity: false,
        newWeight: false,
        newValue: false
    });

    const [useCustomTime, setUseCustomTime] = useState(false);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);

    const handleBlur = (field) => {
        setTouched({ ...touched, [field]: true });
    };

    const inputStyle = (field) => ({
        borderColor: touched[field] && !eval(field) ? 'red' : '#d9d9d9'
    });

    // Envio pedido a siguiente vista

    const showNewProductModal = () => {
        setIsNewProductModalVisible(true);
    };

   

    // Manejar cambio de campos de nuevo producto
    const handleNewProductChange = (e) => {
        const { name, value } = e.target;
        setNewProductData({
            ...newProductData,
            [name]: value
        });
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setNewProductData({
            ...newProductData,
            [name]: Array.from(files)
        });
    };

    // Manejar OK en el modal de creación
    const handleNewProductSave = () => {
        setIsNewProductModalVisible(false);
        const formData = new FormData();
        // As the payload already expects peso_producto in kilos, assume input is in kilos.
        const payload = { ...newProductData };
        Object.keys(payload).forEach(key => {
            formData.append(key, payload[key]);
        });
        console.log("Enviando data del nuevo producto:", payload);
        const url = `https://api.99envios.app/api/inventarios/${id}`;
        fetch(url, {
            method: 'POST',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                message.success('Nuevo producto creado con éxito');
            })
            .catch((error) => {
                console.error('Error:', error);
                message.error('Error al crear el producto');
            });
    };

    // modal viejo
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        console.log('Producto seleccionado:', selectedProducto, 'Cantidad:', cantidad);

        setIsModalVisible(false);
    };

    // Repartidores
    useEffect(() => {
        const fetchRepartidores = async () => {
            const id = localStorage.getItem('usuario_id');
            const url = `https://api.99envios.app/api/conductores-sucursal/${id}`;
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const repartidoresList = await response.json();
                setRepartidores(repartidoresList);
            } catch (error) {
                console.error('Error fetching repartidores:', error);
            }
        };

        fetchRepartidores();
    }, []);

    // Destinos
    useEffect(() => {
        if (isLoaded && window.google) {
            setAutocomplete(new window.google.maps.places.Autocomplete(document.getElementById('autocomplete'), {}));
        }
    }, [isLoaded]);

    // Update helper function to default empty time to "00:00"
    const combineDateAndTime = (dateStr, timeStr) => {
        if (!dateStr) return null;
        const time = timeStr && timeStr.trim() ? timeStr : "00:00";
        return `${dateStr}T${time}:00`;
    };

    const onSaveOrder = async () => {
        if (!productosSeleccionados[0] || !productosSeleccionados[0].id) {
            message.error("Seleccione un producto");
            return;
        }

        // Always default time values to "00:00" if not provided.
        const horaInicioFormatted = combineDateAndTime(fecha_de_entrega, horaInicio);
        const horaFinalFormatted = combineDateAndTime(fecha_de_entrega, horaFinal);

        const payload = {
            cantidad: 1,
            costo_envio: parseInt(costoEnvio, 10) || 1,
            direccion: destination,
            email: email,
            estado: "Espera",
            fecha_de_entrega: combineDateAndTime(fecha_de_entrega, "00:00"),
            fecha_entrega_repartidor: combineDateAndTime(fechaEntregaRepartidor, "00:00"),
            hora_inicio: horaInicioFormatted,
            hora_final: horaFinalFormatted,
            id_producto: parseInt(productosSeleccionados[0].id, 10),
            id_repartidor: selectedRepartidorId ? parseInt(selectedRepartidorId, 10) : null,
            nombre: nombre,
            origin: origin,
            telefono: telefono
        };

        console.log('Sending payload:', payload); // Add this to debug

        const usuario_id = localStorage.getItem('usuario_id');
        const url = `https://api.99envios.app/api/generar-pedido/${usuario_id}`;
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            message.success(`Pedido guardado con éxito con ID: ${data.pedido_id}`);
            navigate('/pedido/rutas', { state: { pedidoIds: [data.pedido_id] } });
        } catch (error) {
            console.error('Error al guardar el pedido:', error);
            message.error('Error al guardar el pedido');
        }
    };

    useEffect(() => {
        const fetchProduct = async () => {
            const id = localStorage.getItem('usuario_id');
            const url = `https://api.99envios.app/api/inventarios/${id}`;
            console.log(url);
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const productList = await response.json();
                const formattedProducts = productList.map(product => ({
                    id: product.id_producto,
                    name: product.nombre_producto
                }));
                setProductos(formattedProducts);
                console.log('Productos:', formattedProducts);
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        fetchProduct();
    }, []);

    // Early returns should come after all hooks
    if (!isLoaded) {
        return <div>Cargando...</div>;
    }
    if (loadError) {
        return <div>Error al cargar la API de Google Maps</div>;
    }

    const calculateRoute = async () => {
        if (!origin || !destination) {
            console.error("Se requieren tanto un origen como un destino para calcular una ruta.");
            return;
        }
        try {
            const directionsService = new window.google.maps.DirectionsService();
            const results = await directionsService.route({
                origin: origin,
                destination: destination,
                optimizeWaypoints: true,
                travelMode: window.google.maps.TravelMode.DRIVING,
            });
            setDirectionsResponse(results);
            console.log("Waypoint Order:", results.routes[0].waypoint_order);
        } catch (error) {
            console.error("Error fetching directions", error);
        }
    };

    const now = new Date();
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    const currentDate = now.toLocaleDateString('es-ES', options);

    const mapZoom = 15;

    const products = [
        { name: '1. Bisuteria' },
        { name: '2. Ropa Deportiva' },
        { name: '3. Vaporizadores' },
        { name: '4. Mascotas' },
        { name: '5. Moda' },
        { name: '6. Tecnologia' },
        { name: '7. Cocina' },
        { name: '8. Belleza' },
        { name: '9. Salud' },
        { name: '10. Hogar' },
        { name: '11. Natural Home' },
        { name: '12. Deportes' },
        { name: '13. Sex Shop' },
        { name: '14. Bebé' },
        { name: '15. Aseo' },
        { name: '16. Bienestar' },
        { name: '17. Camping' },
        { name: '18. Pesca' },
        { name: '19. Defensa Personal' },
        { name: '20. Vehiculos' },
        { name: '21. Jugueteria' },
        { name: '22. Otros' },
    ];

    const agregarProducto = () => {
        setProductosSeleccionados([...productosSeleccionados, { id: '', cantidad: 0 }]);
    };

    const actualizarProducto = (index, value) => {
        const nuevosProductos = [...productosSeleccionados];
        nuevosProductos[index].id = value;
        setProductosSeleccionados(nuevosProductos);
    };

    const actualizarCantidad = (index, value) => {
        const nuevosProductos = [...productosSeleccionados];
        nuevosProductos[index].cantidad = Number(value);
        setProductosSeleccionados(nuevosProductos);
    };

    const onLoadOrigin = (autocomplete) => {
        originRef.current = autocomplete;
    };

    const onLoadDestination = (autocomplete) => {
        destinationRef.current = autocomplete;
    };

    const onPlaceChangedOrigin = () => {
        if (originRef.current) {
            const place = originRef.current.getPlace();
            if (place && place.formatted_address) {
                setOrigin(place.formatted_address);
            }
        }
    };

    const onPlaceChangedDestination = () => {
        if (destinationRef.current) {
            const place = destinationRef.current.getPlace();
            if (place && place.formatted_address) {
                setDestination(place.formatted_address);
            }
        }
    };

    const handleCanceel = () => {
        setIsModalVisible(false);
        setIsNewProductModalVisible(false);
    };

    // Actualiza las opciones de autocompletado
    const autocompleteOptions = {
        componentRestrictions: { country: 'CO' },
        types: ['address'],
        fields: ['formatted_address', 'geometry', 'name', 'place_id'],
        strictBounds: false
    };

    // Add new function to handle map modal
    const showMapModal = () => {
        setIsMapModalVisible(true);
    };

    const handleMapModalCancel = () => {
        setIsMapModalVisible(false);
    };

    const handleTimeSlotSelect = (slot) => {
        setSelectedTimeSlot(slot);
        setHoraInicio(slot.start);
        setHoraFinal(slot.end);
        setUseCustomTime(false);
    };

    const handleCustomTimeToggle = () => {
        setUseCustomTime(true);
        setSelectedTimeSlot(null);
    };

    return (
        <>
           
            <Navbar title={"Crear pedido individual"} />
            <div className="visitas-container fade-in">
                <div className="order-form-container">
                    <form className="edit-order-form" onSubmit={(e) => e.preventDefault()}>
                        {/* Buttons container */}
                        <div className="form-group-envios full-width">
                            <button 
                                type="button" 
                                className="button-success"
                                onClick={showNewProductModal}
                            >
                                Crear Nuevo Producto
                            </button>
                            <button 
                                type="button" 
                                className="button-primary"
                                onClick={showModal}
                            >
                                Seleccionar producto
                            </button>
                            <button 
                                type="button" 
                                className="button-primary"
                                onClick={showMapModal}
                            >
                                Seleccionar Ubicaciones
                            </button>
                        </div>

                        {/* Form fields container */}
                        <div className="form-fields-container">
                            <div className="form-group-envios">
                                <label>PERSONA QUE RECIBE</label>
                                <input
                                    type="text"
                                    placeholder="Nombre del contacto"
                                    onChange={(e) => setNombre(e.target.value)}
                                />
                            </div>

                            <div className="form-group-envios">
                                <label>TELÉFONO</label>
                                <input
                                    type="tel"
                                    placeholder="Número de teléfono"
                                    onChange={(e) => setTelefono(e.target.value)}
                                />
                            </div>

                            <div className="form-group-envios">
                                <label>CORREO ELECTRÓNICO</label>
                                <input 
                                    type="email" 
                                    onChange={(e) => setEmail(e.target.value)} 
                                    placeholder="Añade un correo electrónico" 
                                />
                            </div>

                            <div className="form-group-envios">
                                <label>FECHA DE ENTREGA</label>
                                <input
                                    type="date" 
                                    onChange={(e) => setFechaDeEntrega(e.target.value)}
                                />
                            </div>

                            <div className="form-group-envios">
                                <label>FECHA ENTREGA REPARTIDOR</label>
                                <input
                                    type="date"
                                    onChange={(e) => setFechaEntregaRepartidor(e.target.value)}
                                />
                            </div>

                            <div className="form-group-envios">
                                <label>Comisión del Repartidor</label>
                                <input 
                                    type="number" 
                                    placeholder="Comisión" 
                                    onChange={(e) => setCostoEnvio(e.target.value)} 
                                />
                            </div>
                        </div>

                        {origin && destination && (
                            <div className="locations-summary">
                                <div className="location-item">
                                    <label>Origen:</label>
                                    <span>{origin}</span>
                                </div>
                                <div className="location-item">
                                    <label>Destino:</label>
                                    <span>{destination}</span>
                                </div>
                            </div>
                        )}

                        {/* Time selection container */}
                        <div className="time-selection-container">
                            <div className="time-slots">
                                {TIME_SLOTS.map((slot, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className={`time-slot-button ${selectedTimeSlot === slot ? 'active' : ''}`}
                                        onClick={() => handleTimeSlotSelect(slot)}
                                    >
                                        {slot.label}
                                    </button>
                                ))}
                                <button
                                    type="button"
                                    className={`time-slot-button custom ${useCustomTime ? 'active' : ''}`}
                                    onClick={handleCustomTimeToggle}
                                >
                                    Personalizado
                                </button>
                            </div>

                            {useCustomTime && (
                                <div className="time-window custom">
                                    <div className="time-input-group">
                                        <label>Hora inicio</label>
                                        <input
                                            type="time"
                                            value={horaInicio}
                                            onChange={(e) => setHoraInicio(e.target.value)}
                                            placeholder="00:00"
                                        />
                                    </div>
                                    <span>HASTA</span>
                                    <div className="time-input-group">
                                        <label>Hora final</label>
                                        <input
                                            type="time"
                                            value={horaFinal}
                                            onChange={(e) => setHoraFinal(e.target.value)}
                                            placeholder="23:59"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        <button 
                            type="button" 
                            className="submit-button-envios"
                            onClick={onSaveOrder}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Guardando...' : 'Guardar pedido'}
                        </button>
                    </form>
                </div>

                {/* Map Modal */}
                <Modal
                    title="Seleccionar Ubicaciones"
                    visible={isMapModalVisible}
                    onCancel={handleMapModalCancel}
                    width={1000}
                    footer={null}
                    mask={false}
                    maskClosable={false}
                    style={{ 
                        position: 'relative',
                        zIndex: 1000 
                    }}
                    wrapClassName="locations-modal"
                >
                    <div className="map-modal-content" style={{ position: 'relative' }}>
                        <div className="locations-group">
                            <div className="location-input">
                                <label>Punto de partida</label>
                                <Autocomplete 
                                    onLoad={onLoadOrigin} 
                                    onPlaceChanged={onPlaceChangedOrigin}
                                    options={autocompleteOptions}
                                >
                                    <input
                                        type="text"
                                        placeholder="Ingrese punto de partida"
                                        className="location-input-field"
                                        value={origin}
                                        onChange={(e) => setOrigin(e.target.value)}
                                        style={{ width: '100%' }}
                                    />
                                </Autocomplete>
                            </div>
                            
                            <div className="locations-divider"></div>
                            
                            <div className="location-input">
                                <label>Destino</label>
                                <Autocomplete 
                                    onLoad={onLoadDestination} 
                                    onPlaceChanged={onPlaceChangedDestination}
                                    options={autocompleteOptions}
                                >
                                    <input 
                                        type="text" 
                                        placeholder="Ingrese punto de destino" 
                                        className="location-input-field"
                                        value={destination}
                                        onChange={(e) => setDestination(e.target.value)}
                                        style={{ width: '100%' }}
                                    />
                                </Autocomplete>
                            </div>
                            
                            <button 
                                type="button" 
                                onClick={calculateRoute}
                                className="route-button"
                            >
                                Calcular ruta
                            </button>
                        </div>
                        <div className="map">
                            <GoogleMap
                                mapContainerStyle={mapContainerStyle}
                                center={center}
                                zoom={15}
                                options={{
                                    zoomControl: true,
                                    streetViewControl: false,
                                    mapTypeControl: false,
                                    fullscreenControl: false,
                                }}
                            >
                                {directionsResponse && (
                                    <DirectionsRenderer 
                                        directions={directionsResponse}
                                        options={{
                                            suppressMarkers: false,
                                            polylineOptions: {
                                                strokeColor: "#6366F1",
                                                strokeWeight: 6,
                                            }
                                        }}
                                    />
                                )}
                            </GoogleMap>
                        </div>
                    </div>
                </Modal>

                {/* Other existing modals */}
                <Modal
                    title="Guardar producto"
                    visible={isModalVisible}
                    onOk={handleOk}
                    onCancel={() => setIsModalVisible(false)}
                    className="ant-modal-custom"
                >
                    <div className="ant-modal-body">
                        {productosSeleccionados.map((producto, index) => (
                            <div key={index}>
                                <select
                                    className="ant-select"
                                    value={producto.id}
                                    onChange={(e) => actualizarProducto(index, e.target.value)}
                                >
                                    <option value="">Seleccione un producto</option>
                                    {productos.map(p => (
                                        <option key={p.id} value={p.id}>
                                            Id: {p.id} - {p.name}
                                        </option>
                                    ))}
                                </select>
                                <input
                                    className="ant-input"
                                    type="number"
                                    value={producto.cantidad}
                                    onChange={(e) => actualizarCantidad(index, e.target.value)}
                                    placeholder="Cantidad"
                                />
                            </div>
                        ))}
                        <button type="button" onClick={agregarProducto}>Añadir más productos</button>
                    </div>
                </Modal>

                <Modal
                    title="Crear nuevo producto"
                    visible={isNewProductModalVisible}
                    onOk={handleNewProductSave}
                    onCancel={handleCanceel}
                    className="ant-modal-custom"
                >
                    <div className="ant-modal-body">
                        <div className="ant-row ant-form-item">
                            <div className="ant-col ant-form-item-label">
                                <label>Categoría del producto</label>
                            </div>
                            <div className="ant-col ant-form-item-control">
                                <select className="ant-select" name="id_categoria" onChange={handleNewProductChange} value={newProductData.id_categoria}>
                                    <option value="">Escoge una categoría</option>
                                    <option value="1">Bisuteria</option>
                                    <option value="2">Ropa Deportiva</option>
                                    <option value="3">Vaporizadores</option>
                                    <option value="4">Mascotas</option>
                                    <option value="5">Moda</option>
                                    <option value="6">Tecnologia</option>
                                    <option value="7">Cocina</option>
                                    <option value="8">Belleza</option>
                                    <option value="9">Salud</option>
                                    <option value="10">Hogar</option>
                                    <option value="11">Natural Home</option>
                                    <option value="12">Deportes</option>
                                    <option value="13">Sex Shop</option>
                                    <option value="14">Bebé</option>
                                    <option value="15">Aseo</option>
                                    <option value="16">Bienestar</option>
                                    <option value="17">Camping</option>
                                    <option value="18">Pesca</option>
                                    <option value="19">Defensa Personal</option>
                                    <option value="20">Vehiculos</option>
                                    <option value="21">Jugueteria</option>
                                    <option value="22">Otros</option>
                                </select>
                            </div>
                        </div>
                        <div className="ant-row ant-form-item">
                            <div className="ant-col ant-form-item-label">
                                <label>Nombre del producto</label>
                            </div>
                            <div className="ant-col ant-form-item-control">
                                <input className="ant-input" type="text" name="nombre_producto" onChange={handleNewProductChange} placeholder="Nombre del nuevo producto" />
                            </div>
                        </div>
                        <div className="ant-row ant-form-item">
                            <div className="ant-col ant-form-item-label">
                                <label>Descripción del producto</label>
                            </div>
                            <div className="ant-col ant-form-item-control">
                                <input className="ant-input" type="text" name="descripcion_producto" onChange={handleNewProductChange} placeholder="Descripción" />
                            </div>
                        </div>
                        <div className="ant-row ant-form-item">
                            <div className="ant-col ant-form-item-label">
                                <label>Cantidad disponible para enviar</label>
                            </div>
                            <div className="ant-col ant-form-item-control">
                                <input className="ant-input" type="number" name="cantidad_disponible" onChange={handleNewProductChange} placeholder="Cantidad" />
                            </div>
                        </div>
                        <div className="ant-row ant-form-item">
                            <div className="ant-col ant-form-item-label">
                                <label>Precio Proveedor</label>
                            </div>
                            <div className="ant-col ant-form-item-control">
                                <input className="ant-input" type="number" name="precio_proveedor" onChange={handleNewProductChange} placeholder="Precio Proveedor" />
                            </div>
                        </div>
                        <div className="ant-row ant-form-item">
                            <div className="ant-col ant-form-item-label">
                                <label>Precio Sugerido</label>
                            </div>
                            <div className="ant-col ant-form-item-control">
                                <input className="ant-input" type="number" name="precio_sugerido" onChange={handleNewProductChange} placeholder="Precio Sugerido" />
                            </div>
                        </div>
                        <div className="ant-row ant-form-item">
                            <div className="ant-col ant-form-item-label">
                                <label>Peso del producto (en kilogramos)</label>
                            </div>
                            <div className="ant-col ant-form-item-control">
                                <input className="ant-input" type="number" name="peso_producto" onChange={handleNewProductChange} placeholder="Peso del producto" />
                            </div>
                        </div>
                        <div className="ant-row ant-form-item">
                            <div className="ant-col ant-form-item-label">
                                <label>SKU</label>
                            </div>
                            <div className="ant-col ant-form-item-control">
                                <input className="ant-input" type="text" name="sku" onChange={handleNewProductChange} placeholder="SKU" />
                            </div>
                        </div>
                        <div className="ant-row ant-form-item">
                            <div className="ant-col ant-form-item-label">
                                <label>Estado de Variación</label>
                            </div>
                            <div className="ant-col ant-form-item-control">
                                <input className="ant-input" type="checkbox" name="estado_variacion" onChange={handleNewProductChange} />
                            </div>
                        </div>
                    </div>
                </Modal>

            </div>
            <BotonWhatsapp />
            <Footer />
        </>
    );
};

export default Visitas;
